// ----------------------------------------------------------------------------
// Component: Page Header for Quiz results page
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import './_quiz-results-header.scss';
